import { Component, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SecurityContext, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  EError,
  EImageSize, EPackagingType, EProductAvailabilityState, EShoppingCartGetQueryType, ETechGroupFeatureUsage, ProductDetailDto,
  ProductIdentifierDto, ProductPriceDto, ProductPriceInfoGetItemDto, ProductPromotionDto, ProductStockInformationGetDto,
  QuantityUnitDto, ShoppingCartDto, ShoppingCartItemDto, ShoppingCartItemIdentifierDto,
  ShoppingCartSetItemDto
} from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';
import { ProductCompareService } from 'projects/shared/lib/services/infrastructure/product-compare/product-compare.service';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { BasicError } from 'projects/shared/lib/error/basic-error';
import { Router } from '@angular/router';
import { IProductListEnvironment } from 'projects/shared/lib/interfaces/environment/product/product-list-environment.interface';
import { EViewType } from 'projects/shared/lib/enum/view-type/view-type.enum';
import { ELoadingIndicatorStyle } from 'projects/shared/lib/enum/loading/loading-indicator-style.enum';
import { EQuantityValidationResult } from 'projects/shared/lib/enum/quantity/quantity-validation-result.enum';
import { QuantityInputBareChangeResult } from 'projects/shared/lib/components/shared/base/quantity-input/quantity-input-bare/change-result/quantity-input-bare-change-result.model';
import { ProductAddToCartDialog } from 'projects/shared/lib/components/shared/product/add-to-cart-dialog/product-add-to-cart-dialog.model';
import { ProductCompareIcon } from 'projects/shared/lib/components/shared/product/compare-icon/product-compare-icon.model';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { IProductAddToCartDialogService, IProductAddToCartDialogServiceToken } from 'projects/shared/lib/interfaces/services/dialogs/product-add-to-cart-dialog-service.abstract';
import { ICartService, ICartServiceToken } from 'projects/shared/lib/services/data/cart/cart-service.interface';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';
import { IProductService, IProductServiceToken } from 'projects/shared/lib/services/data/product/product-service.interface';
import { ProductListItem } from '../product-list-item.model';
import { IProductAvailabilityNotificationConfirmationDialogService } from 'projects/shared/lib/interfaces/services/dialogs/product-availability-notification-confirmation-dialog-service.abstract';
import { IContextService, IContextServiceToken } from 'projects/shared/lib/services/infrastructure/context/context-service.interface';
import { ICartCreationDialogService } from 'shared/services/ui/cart-creation-dialog/cart-creation-dialog-service.abstract';
import { ProductMHService } from 'projects/munhowen/src/app/services/data/product/product.service';
import { IAvailabilityNotificationService, IAvailabilityNotificationServiceToken } from 'projects/shared/lib/services/data/availability-notification/availability-notification-service.interface';
import { ErrorCodeService } from 'projects/shared/lib/services/infrastructure/error-code.service';
import { ISalesUnitService, ISalesUnitServiceToken } from 'projects/shared/lib/services/infrastructure/salesunit/salesunit-service.interface';
import { IConfigurationService, IConfigurationServiceToken } from 'projects/shared/lib/services/infrastructure/configuration/configuration-service.interface';
import { IComparisonService, IComparisonServiceToken } from 'projects/shared/lib/services/infrastructure/comparison/comparison-service.interface';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';
import { IPriceTemplateService, IPriceTemplateServiceToken } from 'shared/services/ui/price-template/price-template-service.interface';

@Component({
  template: '',
  standalone: false
})
export class ProductListItemMHComponent implements OnInit, OnChanges, OnDestroy {
  private readonly salesUnitService: ISalesUnitService = inject(ISalesUnitServiceToken);

  @Input() public productIdentifier?: ProductIdentifierDto;
  @Input() public productListProduct: ProductListItem;

  @Output() public onProductRemove: EventEmitter<void>;

  protected logger: LoggerService;
  protected readonly cartDataService: ICartService;
  private readonly toastService: IToastService = inject(IToastServiceToken);
  private readonly productService: IProductService;
  private productCompareService: ProductCompareService;
  private sanitizer: DomSanitizer;
  public readonly authService: IAuthService;
  private readonly comparisonService: IComparisonService;
  private readonly priceTemplateService: IPriceTemplateService = inject(IPriceTemplateServiceToken);
  private router: Router;
  private productAddToCartDialogService: IProductAddToCartDialogService;
  public acceptQuantityChangeTrigger: Subject<void>;
  public rejectQuantityChangeTrigger: Subject<void>;
  private readonly availabilityNotificationService: IAvailabilityNotificationService;
  public readonly contextService: IContextService;
  private readonly configurationService: IConfigurationService = inject(IConfigurationServiceToken);

  public eLoadingIndicatorStyle: ELoadingIndicatorStyle;

  public productCompareIcon: ProductCompareIcon;

  private comparisonProductSubscription: Subscription | undefined;
  protected shouldLoadPrices: boolean | undefined;
  private authenticationSubscription: Subscription | undefined;
  public shouldBlockAddToCart: boolean | undefined;
  private shoppingCartSubscription: Subscription | undefined;
  private permissionSubscription: Subscription | undefined;

  private productListSetting: IProductListEnvironment | undefined;
  protected viewType: EViewType;

  public shoppingCartItem: ShoppingCartItemDto | undefined;
  public minimumOrderAmount: number;
  public maximumOrderAmount: number;
  public isAuthenticated: boolean;

  public isShoppingCartDefined: boolean | undefined;
  public eProductAvailabilityState: typeof EProductAvailabilityState;

  public eTechGroupFeatureUsage: typeof ETechGroupFeatureUsage;
  public ePackagingType: typeof EPackagingType;
  private cart: ShoppingCartDto | undefined;
  public isExportBanned: boolean | undefined;
  public isLoading: boolean | undefined;

  public constructor() {
    this.onProductRemove = new EventEmitter();

    this.logger = ServiceLocator.injector.get(LoggerService);
    this.cartDataService = inject(ICartServiceToken);
    this.productService = inject(IProductServiceToken);
    this.productCompareService = ServiceLocator.injector.get(ProductCompareService);
    this.sanitizer = ServiceLocator.injector.get(DomSanitizer);
    this.authService = inject(IAuthServiceToken);
    this.comparisonService = inject(IComparisonServiceToken);
    this.router = ServiceLocator.injector.get(Router);
    this.productAddToCartDialogService = inject(IProductAddToCartDialogServiceToken);
    this.availabilityNotificationService = inject(IAvailabilityNotificationServiceToken);
    this.contextService = inject(IContextServiceToken);

    this.eLoadingIndicatorStyle = ELoadingIndicatorStyle.EMBEDDED;
    this.productListSetting = ENVIRONMENT.productList;
    this.viewType = ENVIRONMENT.productList.productListDefaultViewType;
    this.isAuthenticated = this.authService.isAuthenticated();
    this.shouldLoadPrices = this.shouldLoadPricesCurrentStateGet();

    this.productListProduct = new ProductListItem(this.configurationService);
    this.productCompareIcon = new ProductCompareIcon();

    this.minimumOrderAmount = 1;
    this.maximumOrderAmount = ENVIRONMENT.checkout.maximumOrderAmount;
    this.checkoutConfigurationCheckAsync();

    this.eProductAvailabilityState = EProductAvailabilityState;
    this.acceptQuantityChangeTrigger = new Subject<void>();
    this.rejectQuantityChangeTrigger = new Subject<void>();

    this.eTechGroupFeatureUsage = ETechGroupFeatureUsage;
    this.ePackagingType = EPackagingType;
  }

  ngOnInit() {
    this.productListProduct.productStockIsLoading = true;
    this.comparisonProductSubscriptionInit();
    this.authenticationSubscriptionInit();
    this.shoppingCartSubscriptionInit();
    this.permissionSubscriptionInit();
  }

  public ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];
      switch (propName) {
        case 'productIdentifier': {
          // if (this.productListProduct == undefined) {
          this.initByProductIdentifier(change.currentValue);
          // }
          break;
        }
        case 'productListProduct': {
          this.initByProductListProduct(change.currentValue);
          break;
        }
        default: {
          throw new Error('Input property handler not implemented.');
        }
      }
    }
  }

  public ngOnDestroy(): void {
    this.comparisonProductSubscription?.unsubscribe();
    this.authenticationSubscription?.unsubscribe();
    this.shoppingCartSubscription?.unsubscribe();
    this.permissionSubscription?.unsubscribe();
  }

  private async checkoutConfigurationCheckAsync() {
    let checkoutConfiguration = await firstValueFrom(ServiceLocator.injector.get(IConfigurationServiceToken).checkoutConfigurationGet());
    if (checkoutConfiguration.maximumOrderAmount != undefined) {
      this.maximumOrderAmount = checkoutConfiguration.maximumOrderAmount;
    }
  }

  private shoppingCartSubscriptionInit() {
    if (!this.shoppingCartSubscription) {
      this.shoppingCartSubscription = this.cartDataService.cartCurrentChangedGet().subscribe(
        (cart) => {
          this.cart = cart;
          this.isShoppingCartDefined = cart != undefined;
          let shoppingCartItem = cart?.itemList?.find(i => this.comparisonService.equalsProductIdentifierByNumberOrGuid(i.productIdentifier, this.productListProduct.productIdentifier));
          let wasItemRemovedFromCart = this.shoppingCartItem != undefined && shoppingCartItem == undefined;
          let wasItemAddedToCart = this.shoppingCartItem == undefined && shoppingCartItem != undefined;
          let wasItemAlreadyInCart = this.shoppingCartItem != undefined && shoppingCartItem != undefined;

          if (wasItemRemovedFromCart) {
            // reset / undo changes in correlation to cart
            this.initSalesUnitByPromotionData(this.productListProduct.promotionDataList);
            this.shoppingCartItem = undefined;
            this.productListProductUpdate(undefined);
          }

          if (wasItemAddedToCart || wasItemAlreadyInCart) {
            // update / sync in correlation
            this.shoppingCartItem = shoppingCartItem;
            this.productListProductUpdate(shoppingCartItem);
          }

          let isExportBanRelevant = this.cart?.deliveryAddressData?.countryCode !== ENVIRONMENT.operatorCountrySingleCharLanguageCode;
          if (this.productListProduct.hasExportBan && isExportBanRelevant) {
            this.isExportBanned = true;
          }
        }
      );
    }
  }

  private authenticationSubscriptionInit() {
    if (!this.authenticationSubscription) {
      this.authenticationSubscription = this.authService.authenticatedGet().subscribe(
        (isAuthenticated) => {
          this.isAuthenticated = isAuthenticated;
          this.shouldLoadPrices = this.shouldLoadPricesCurrentStateGet();

          let allowAnonymousAddToCart = ENVIRONMENT.allowAnonymousAddToCart;
          this.shouldBlockAddToCart = allowAnonymousAddToCart == false && isAuthenticated == false;
        }
      );
    }
  }

  private comparisonProductSubscriptionInit() {
    if (!this.comparisonProductSubscription) {
      this.comparisonProductSubscription = this.productCompareService.productIdentifierListChangeGet().subscribe({
        next: (productIdentifierList: ProductIdentifierDto[]) => {
          let match = productIdentifierList.find(
            (productIdentifier: ProductIdentifierDto) => this.comparisonService.equalsProductIdentifierByNumberOrGuid(productIdentifier, this.productListProduct.productIdentifier)
          );

          if (!match && this.productCompareIcon.isInComparison) {
            this.productCompareIcon.isInComparison = false;
          }
          if (match && !this.productCompareIcon.isInComparison) {
            this.productCompareIcon.isInComparison = true;
          }

        },
        error: (er) => {
          this.logger.error(`${er}`, this.constructor.name);
        },
      });
    }
  }

  private permissionSubscriptionInit() {
    if (!this.permissionSubscription) {
      this.permissionSubscription = this.authService.userPermissionChangedGet().subscribe(
        () => {
          this.shouldLoadPrices = this.shouldLoadPricesCurrentStateGet();
        }
      );
    }
  }

  protected shouldLoadPricesCurrentStateGet(): boolean {
    return ENVIRONMENT.price.allowAnonymousPrice || (this.authService.isAuthenticated() && this.authService?.canSeePrices());
  }

  private productListProductUpdate(shoppingCartItem: ShoppingCartItemDto | undefined) {
    if (shoppingCartItem == undefined) {
      this.productListProduct.quantity = 1;
    } else {
      let quantity = this.shoppingCartItem?.quantity != undefined ? this.shoppingCartItem?.quantity : this.productListProduct.minimumOrderAmount;
      this.productListProduct.quantity = quantity;

      if (this.productListProduct.salesUnit?.quantityUnit !== this.shoppingCartItem?.orderUnit?.quantityUnit) {
        this.productListProduct.salesUnit = this.shoppingCartItem?.orderUnit;

        if (this.shouldLoadPrices) {
          this.productPriceLoad(this.productListProduct);
        }
      }
    }
  }

  private async initByProductIdentifier(change: any) {
    let productIdentifier: ProductIdentifierDto = change as ProductIdentifierDto;
    let isProductIdentifierValid = productIdentifier != undefined && (productIdentifier.productGuid != undefined || productIdentifier.productNumber != undefined);
    let isProductListProductProductIdentifierEmpty = this.productListProduct.productIdentifier == undefined || (this.productListProduct.productIdentifier.productGuid == undefined && this.productListProduct.productIdentifier.productNumber == undefined);

    if (isProductListProductProductIdentifierEmpty && isProductIdentifierValid) {
      this.productListProduct.productIdentifier = productIdentifier;
      this.productCompareIcon.productIdentifier = productIdentifier;
    }

    if (!this.productListProduct.productIdentifier) {
      this.toastService.toastItemAdd(new ToastItem({
        type: EToastItemType.Danger,
        title: $localize`:@@ProductListProductInitProductReferenceErrorTitle:Failure`,
        message: $localize`:@@ProductListProductInitProductReferenceErrorMessage:The reference to the product is missing.`,
        code: ErrorCodeService.formatErrorCode(EError.F140011)
      }));
      return;
    }

    this.productDetailLoad(this.productListProduct.productIdentifier);
    this.productThumbnailLoad(this.productListProduct.productIdentifier);

    if (this.shouldLoadPrices) {
      this.productPriceLoad(this.productListProduct);
    }
    if (this.isAuthenticated) {
      this.productStockInformationLoad(this.productListProduct.productIdentifier);
    }
    this.productListProduct.productStockIsLoading = false;
  }

  private initByProductListProduct(change: any) {
    let productListProduct: ProductListItem = change as ProductListItem;
    this.productCompareIcon.productIdentifier = productListProduct.productIdentifier;

    this.minimumOrderAmount = productListProduct?.minimumOrderAmount ? productListProduct?.minimumOrderAmount : 1;
    this.initSalesUnitByPromotionData(productListProduct.promotionDataList);
  }

  public async createCartClickAsync(cart?: ShoppingCartDto | undefined) {
    if (cart == undefined) {
      // try looking for an "old" one
      await firstValueFrom(this.cartDataService.cartGet(EShoppingCartGetQueryType.GetLatestOrCreateNew, false)).then((result) => {
        cart = result.shoppingCart;
      }).catch((error) => {
        this.logger.error(error, this.constructor.name);
        let errorMessage = $localize`:@@ProductListItemBaseCreateCartErrorMessage:Could not create cart`;
        throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
      });
    }
    ServiceLocator.injector.get(ICartCreationDialogService).cartCreationDialogShow(
      () => { },
      cart
    );
  }

  public addToCartDialogClick(productListProduct: ProductListItem): void {
    if (this.shouldBlockAddToCart == true) {
      this.toastService.toastItemAdd(new ToastItem({
        type: EToastItemType.Warning,
        message: $localize`:@@ProductListProductAddToCartBlockedRedirectMessage:Please login to order`,
        code: ErrorCodeService.formatErrorCode(EError.F140021)
      }));
      this.router.navigate(['/login']);
      return;
    }

    if (!productListProduct.productIdentifier) {
      return;
    }

    let matchingShoppingCartItemDto: ShoppingCartItemDto | undefined = this.cartDataService.cartItemGetByIdentifier(this.productListProduct.productIdentifier);

    let deliveryInformation = matchingShoppingCartItemDto ? matchingShoppingCartItemDto.deliveryInformation : '';
    let quantity = matchingShoppingCartItemDto ? matchingShoppingCartItemDto.quantity : productListProduct.minimumOrderAmount;
    let minimumOrderAmount = productListProduct.minimumOrderAmount;

    this.productAddToCartDialogService.productAddToCartDialogShow(
      new ProductAddToCartDialog(
        this.configurationService,
        {
          productIdentifier: productListProduct.productIdentifier,
          deliveryInformation: deliveryInformation,
          quantity: quantity,
          minimumOrderAmount: minimumOrderAmount,
          orderUnit: productListProduct.salesUnit
        }
      )
    );
  }

  public async addToCartClickAsync(productListProduct: ProductListItem): Promise<void> {
    try {
      this.isLoading = true;
      if (productListProduct.productIdentifier == undefined) {
        return;
      }

      if (productListProduct.quantity == undefined) {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Warning,
          message: $localize`:@@ProductListProductAddToCartMissingQuantityMessage:Quantity missing`,
          code: ErrorCodeService.formatErrorCode(EError.F140031)
        }));
        return;
      }

      if (productListProduct.quantity <= 0 || (productListProduct.minimumOrderAmount != undefined && productListProduct.quantity < productListProduct.minimumOrderAmount)) {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Warning,
          message: $localize`:@@ProductListProductAddToCartQuantityBelowMinimumMessage:Quantity below the minimum amount`,
          code: ErrorCodeService.formatErrorCode(EError.F140041)
        }));
        return;
      }

      if (productListProduct.maximumOrderAmount != undefined && productListProduct.quantity > productListProduct.maximumOrderAmount) {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Warning,
          message: $localize`:@@ProductListProductAddToCartQuantityAboveMaximumMessage:Quantity above the maximum amount`,
          code: ErrorCodeService.formatErrorCode(EError.F140051)
        }));
        return;
      }

      let result = await this.cartDataService.cartItemSetByProductIdentifierAsync(
        undefined,
        productListProduct.productIdentifier,
        productListProduct.quantity,
        productListProduct.salesUnit
      ).catch((ex) => {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          message: $localize`:@@ProductListProductAddToCartErrorMessage:Could not add product to shopping cart`,
          code: JSON.parse(ex.response).errorCode
        }));
      });
      if (result != undefined) {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          message: $localize`:@@ProductListProductAddToCartSuccessMessage:Shopping cart updated`
        }));
        this.updateItemInCartAsync(productListProduct.productIdentifier, 1, undefined);
      }
    }
    catch {
      if (productListProduct.productIdentifier != undefined) {
        throw new BasicError(`Could not add product "${productListProduct.productIdentifier.productNumber}" to shopping cart`, ErrorCodeService.formatErrorCode(EError.F170051));
      }
    }
    finally {
      this.isLoading = false;
    }
  }

  private async productDetailLoad(productIdentifier: ProductIdentifierDto) {
    await firstValueFrom(this.productService.productDetailGet(false, true, false, false, false, true, false, undefined, [productIdentifier])).then((productDetailGetQueryResult) => {
      let productDetailDtoList = productDetailGetQueryResult.productList;
      if (!productDetailDtoList || productDetailDtoList.length < 1) {
        return;
      }

      let productDetail: ProductDetailDto = productDetailDtoList[0];
      this.productListProduct.description = productDetail.description;
      this.productListProduct.isFavorite = productDetail.isFavorite;
      this.productListProduct.minimumOrderAmount = productDetail.minimumOrderAmount;
      if (this.productListProduct.salesUnit == undefined) {
        let salesUnitDefault = this.salesUnitService.defaultSalesUnitGet(productDetail.salesUnitList);
        this.productListProduct.salesUnit = salesUnitDefault;
      }
      // this.productListProduct.techGroupNumber = productDetail.techGroupNumber;
      this.productListProduct.toolTipText = productDetail.toolTipText;
      this.minimumOrderAmount = productDetail?.minimumOrderAmount ? productDetail?.minimumOrderAmount : 1;
    }).catch((error) => {
      this.logger.error(error, this.constructor.name);
      let errorMessage = $localize`:@@ProductListItemBaseLoadProductErrorMessage:Could not load products`;
      throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
    });
  }

  private async productStockInformationLoad(productIdentifier: ProductIdentifierDto, quantityUnit?: QuantityUnitDto | undefined) {
    let productStockInformationGetItem = new ProductStockInformationGetDto({
      productIdentifier: productIdentifier,
      quantityUnit: quantityUnit?.quantityUnit
    });

    await firstValueFrom(this.productService.productStockInformationGet([productStockInformationGetItem], this.cart?.deliveryDate)).then((result) => {
      let productStockInformationList = result.productStockInformationList;
      if (!productStockInformationList || productStockInformationList.length < 1) {
        return;
      }

      this.productListProduct.productStockInformation = productStockInformationList.find(p => {
        return this.comparisonService.equalsProductIdentifierByNumberOrGuid(p.productIdentifier, productIdentifier);
      });
    }).catch((error) => {
      this.logger.error(error, this.constructor.name);
      let errorMessage = $localize`:@@ProductListItemBaseLoadStockInformationErrorMessage:Could not load product availabilities`;
      throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
    });
  }

  private async productThumbnailLoad(productIdentifier: ProductIdentifierDto) {
    let imageSize: EImageSize | undefined;
    switch (this.viewType) {
      case EViewType.GRID:
        imageSize = this.productListSetting?.productGridThumbnailSize;
        break;
      case EViewType.LIST:
        imageSize = this.productListSetting?.productListThumbnailSize;
        break;
    }

    if (imageSize == undefined) {
      imageSize = EImageSize.Medium;
    }

    try {
      let productThumbnailGetQueryResult = await firstValueFrom(this.productService.productThumbnailGet(imageSize, [productIdentifier]));

      let productImageDtoList = productThumbnailGetQueryResult.productList;
      if (!productImageDtoList || productImageDtoList.length < 1) {
        return;
      }

      let thumbnailDto = productImageDtoList[0];

      let sanitizedThumbnail = this.sanitizer.sanitize(SecurityContext.URL, `data:${thumbnailDto.contentType};base64,${thumbnailDto.content}`);
      if (!sanitizedThumbnail) {
        return;
      }

      this.productListProduct.thumbnail = sanitizedThumbnail;
    } catch (error) {
      this.logger.warn(error, this.constructor.name);
    }
  }

  private async productPriceLoad(productListProduct: ProductListItem) {
    let productPriceGetItem = new ProductPriceInfoGetItemDto({
      productIdentifier: productListProduct.productIdentifier,
      orderUnit: productListProduct.salesUnit?.quantityUnit
    });

    await firstValueFrom(this.productService.productPriceInfoGet([productPriceGetItem])).then((productPriceGetQueryResult) => {
      let productPriceDtoList: ProductPriceDto[] | undefined = productPriceGetQueryResult.productList;
      if (!productPriceDtoList || productPriceDtoList.length < 1) {
        return;
      }

      let productPriceDto: ProductPriceDto | undefined = productPriceDtoList.find(
        (productPrice: ProductPriceDto) => this.comparisonService.equalsProductIdentifierByNumberOrGuid(productPrice.productIdentifier, productListProduct.productIdentifier)
      );

      if (!productPriceDto) {
        this.logger.info(`Could not map productPriceGetQueryResult to productPriceGetEntry`, this.constructor.name);
        return;
      }

      if (productPriceDto?.productComplexPriceList != undefined) {
        this.productListProduct.priceTemplateData = this.priceTemplateService.productPriceTemplateGetByProductComplexPrice(productPriceDto.productComplexPriceList);
      }
    }).catch((error) => {
      this.logger.error(error, this.constructor.name);
      let errorMessage = $localize`:@@ProductListItemBaseLoadPriceErrorMessage:Could not load product prices`;
      throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
    });
  }

  public async quantityChangedAsync(quantityChangeResult: QuantityInputBareChangeResult) {
    let productIdentifier = this.productListProduct.productIdentifier;
    if (productIdentifier == undefined) {
      return;
    }

    let quantity = quantityChangeResult.valueCurrent;

    switch (quantityChangeResult.validationResult) {
      case undefined:
        return;

      case EQuantityValidationResult.Valid:
        if (quantity == undefined) {
          return;
        }

        this.updateItemInCartAsync(productIdentifier, quantity, undefined);
        break;

      case EQuantityValidationResult.BelowMinium:
        this.deleteFromCart();
        break;

      case EQuantityValidationResult.AboveMaximum:
        if (quantity == undefined) {
          return;
        }

        this.updateItemInCartAsync(productIdentifier, quantity, undefined);
        break;


      default:
        break;
    }
  }

  public async updateItemInCartAsync(productIdentifier: ProductIdentifierDto, quantity: number, skipStockInfo: boolean | undefined) {
    if (skipStockInfo == undefined) {
      skipStockInfo = false;
    }

    let shoppingCartSetItem = new ShoppingCartSetItemDto();
    shoppingCartSetItem.quantity = quantity;

    let shoppingCartItemIdentifier = new ShoppingCartItemIdentifierDto();
    shoppingCartItemIdentifier.productIdentifier = productIdentifier;

    let orderUnit = this.shoppingCartItem?.orderUnit?.quantityUnit;
    if (orderUnit == undefined) {
      orderUnit = this.productListProduct.salesUnit?.quantityUnit;
    }
    shoppingCartItemIdentifier.orderUnit = orderUnit;

    shoppingCartSetItem.shoppingCartItemIdentifier = shoppingCartItemIdentifier;

    try {
      let shoppingCart: ShoppingCartDto | undefined = await this.cartDataService.cartItemListSetAsync(undefined, [shoppingCartSetItem]);
      if (shoppingCart == undefined) {
        this.rejectQuantityChangeTrigger.next();
        return;
      }
      this.cartDataService.cartCurrentReplaceBy(shoppingCart);
      let shoppingCartItem = shoppingCart?.itemList?.find(
        (i) => this.comparisonService.equalsProductIdentifierByNumberOrGuid(i.productIdentifier, productIdentifier));

      if (shoppingCartItem == undefined) {
        this.rejectQuantityChangeTrigger.next();
        return;
      }

      if (!skipStockInfo) {
        let productStockInformationGetItem = new ProductStockInformationGetDto({
          productIdentifier: shoppingCartItem.productIdentifier,
          quantityUnit: shoppingCartItem.orderUnit?.quantityUnit
        });

        let result = await firstValueFrom(ServiceLocator.injector.get(ProductMHService).productStockInformationGet([productStockInformationGetItem], shoppingCart.deliveryDate));
        let productStockInformationList = result.productStockInformationList;
        let productStockInformation = productStockInformationList?.find(i => this.comparisonService.equalsProductIdentifierByNumberOrGuid(i.productIdentifier, productIdentifier));

        if (productStockInformation) {
          if (quantity > productStockInformation.availableQuantity) {
            shoppingCartItem.quantity = Math.floor(productStockInformation.availableQuantity);
            this.rejectQuantityChangeTrigger.next();
            this.updateItemInCartAsync(productIdentifier, shoppingCartItem.quantity, true);
            return;
          }
        }
      }

      this.shoppingCartItem = shoppingCartItem;
      this.acceptQuantityChangeTrigger.next();
    } catch (error) {
      this.rejectQuantityChangeTrigger.next();
      this.logger.error(error, this.constructor.name);
    }

  }

  public deleteFromCart() {
    if (this.productListProduct.productIdentifier == undefined) {
      return;
    }

    this.initSalesUnitByPromotionData(this.productListProduct.promotionDataList);

    this.cartDataService.cartItemListDeleteAsync([this.productListProduct.productIdentifier], undefined, true).then(
      (shoppingCart: ShoppingCartDto | undefined) => {
        this.shoppingCartItem = undefined;
      }).catch(
        () => {
          if (this.shoppingCartItem == undefined) {
            return;
          }
        }
      );
  }

  public async availabilityNotificationCreateClickAsync(product: ProductListItem) {

    ServiceLocator.injector.get(IProductAvailabilityNotificationConfirmationDialogService).productAvailabilityNotificationConfirmationDialogShow(
      () => {
        // cancel
      },
      async () => {
        // yes
        if (product.productIdentifier == undefined) { return; }

        await firstValueFrom(this.availabilityNotificationService.availabilityNotificationCreate([product.productIdentifier])).then((result) => {
          if (result == undefined) {
            // failure
            return;
          }

          // success
          product.hasAvailabilityNotification = true;
        }).catch((error) => {
          this.logger.error(error, this.constructor.name);
          let errorMessage = $localize`:@@ProductListItemBaseSetAvailabilityNotificationErrorMessage:Could not create availability notification`;
          throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
        });
      },
      () => {
        // no
      }
    );

  }

  public async availabilityNotificationDeleteClickAsync(product: ProductListItem) {
    if (product.productIdentifier == undefined) { return; }

    await firstValueFrom(this.availabilityNotificationService.availabilityNotificationDelete([product.productIdentifier])).then((result) => {
      if (result == undefined) {
        // failure
        return;
      }

      // success
      product.hasAvailabilityNotification = false;
    }).catch((error) => {
      this.logger.error(error, this.constructor.name);
      let errorMessage = $localize`:@@ProductListItemBaseSetAvailabilityNotificationErrorMessage:Could not create availability notification`;
      throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
    });
  }

  public initSalesUnitByPromotionData(promotionDataList: ProductPromotionDto[] | undefined) {
    if (promotionDataList == undefined) {
      return;
    }

    let promotionData = promotionDataList;
    let hasPromotionData = false;
    hasPromotionData = (promotionData.length > 0);
    if (hasPromotionData) {
      this.productListProduct.salesUnit = promotionData[0].perQuantityUnit;
      this.productPriceLoad(this.productListProduct);
    }
  }

}
